import { useEffect, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import { asset, money } from "../../utils/format";
import { quantityDetail, selectionSummary, SELLER_MESSENGER_URL, messengerTarget } from "../../utils/order";

export default function OrderSummary({ order }) {
  const [status, setStatus] = useState(false);
  const [actionsHost, setActionsHost] = useState(null);
  useEffect(() => setStatus(false), [order.text]);
  useLayoutEffect(() => {
    const media = window.matchMedia?.("(min-width: 1200px)");
    if (!media) return undefined;
    const update = () => setActionsHost(media.matches ? document.getElementById("bagTotalActions") : null);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  const copy = async () => {
    const target = messengerTarget();
    let request;
    try { request = navigator.clipboard.writeText(order.text); }
    catch { request = Promise.reject(new Error("Clipboard unavailable")); }
    // Initiate copying before handing focus to the Messenger app.
    if (target === SELLER_MESSENGER_URL) window.open(target, "_blank", "noopener,noreferrer");
    else window.location.href = target;
    try {
      await request;
      setStatus(true);
    } catch {
      window.prompt("Copy these order details:", order.text);
    }
  };

  const actions = (
    <div className="orderActions">
      <div className="copyConfirm isCopied" id="copyStatus">
        <div role="status" aria-live="polite">
          <strong className="copySuccessTitle">{status ? "✓ Order details copied" : "Order details copied"}</strong>
          <p className="copyNextStep">Tap <strong>Send an Inquiry</strong>, <strong>Paste</strong> and press <strong>Send</strong>.</p>
          <p className="copyNextStep">I do not accept online payment. Pay cash at pickup or message me to arrange payment.</p>
        </div>
        <button type="button" className="primary messengerOrderButton" id="copyOrderDetails" onClick={copy}>
          Send an Inquiry
        </button>
        {status && <p className="copyFallbackLabel" style={{ marginTop: 12 }}>
          App didn’t open? <a className="messengerBrowserFallback" href={SELLER_MESSENGER_URL} target="_blank" rel="noopener noreferrer">Open chat in your browser</a>
        </p>}
      </div>
    </div>
  );

  return (
    <>
      <div className="orderSummary" id="orderSummary">
        <div className="orderSummaryHead">
          <strong>Order Details for Inquiry (Not an Invoice)</strong>
          {order.name && <div style={{ marginTop: 4 }}>
            <strong>Name: {order.name}</strong>
          </div>}
        </div>
        <div style={{ padding: "7px 12px 1px", fontSize: 11, fontWeight: 800 }}>Items</div>
        {order.rows.map((row, i) => (
          <div className="orderItem" key={row.item.id}>
            <img src={asset(row.item.image)} alt="" />
            <div>
              <div className="orderItemName">
                {i + 1}. {row.item.name}
              </div>
              {selectionSummary(row) && <div className="orderItemMeta">{selectionSummary(row)}</div>}
              <div className="orderItemMeta">{quantityDetail(row)}</div>
              <div className="orderItemMeta">Price: {money(row.total)}</div>
            </div>
          </div>
        ))}
        <div className="orderSummaryTotal">
          <span>Total</span>
          <span>{money(order.total)}</span>
        </div>
        {order.notes && (
          <div style={{ padding: "0 12px 10px" }}>
            <strong>Note to seller:</strong> {order.notes}
          </div>
        )}
      </div>
      {actionsHost ? createPortal(actions, actionsHost) : actions}
      <div className="drawerDisclaimer">
        <strong>Product &amp; Availability Disclaimer:</strong> Availability, shades, colours, sizes, quantities and prices
        may change and are not guaranteed until confirmed. Photos are for reference; actual colours and packaging may vary.
        Adding an item to an inquiry does not reserve or purchase it. Totals are estimates and availability will be
        confirmed before arrangements are finalized.
      </div>
    </>
  );
}
